import { render } from "./IncreaseButton.vue?vue&type=template&id=4c669878"
import script from "./IncreaseButton.vue?vue&type=script&lang=js"
export * from "./IncreaseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__